import { render, staticRenderFns } from "./industryAdvantageWidge.vue?vue&type=template&id=0ef8d3d0&scoped=true"
import script from "./industryAdvantageWidge.vue?vue&type=script&lang=js"
export * from "./industryAdvantageWidge.vue?vue&type=script&lang=js"
import style0 from "./industryAdvantageWidge.vue?vue&type=style&index=0&id=0ef8d3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8d3d0",
  null
  
)

export default component.exports